import { Box, Container, Divider, Grid, Link } from "@mui/material";
import React from "react";
import Typography from "@mui/material/Typography";
import { useLocation } from "react-router-dom";

function Livestreaming() {
  const location = useLocation();
  const liveStreamingUrlData = location.state?.liveStreamingUrlData;

  return (
    <>
      <Container maxWidth={'xl'} className="page-header py-4 breadcrumb-bg">
        <h1 className="text-center display-6 breadcrumb-h1"> LIVE Streaming</h1>
        <ol className="breadcrumb justify-content-center mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item active"> LIVE Streaming</li>
        </ol>
      </Container>
      <Container className="py-5">
        <Grid className="text-center mb-5">
          <h6 className="section-title text-center text-primary text-uppercase title-tl">
            LIVE Streaming
          </h6>
          <h1 className="mb-3">
            <span className="text-secundary">Available during</span>
          </h1>
        </Grid>
        <Grid className="row mb-5">
          <Typography variant="body1" gutterBottom sx={{ mb: 2 }}>
            <strong>Event Name</strong> : Live Videos
          </Typography>
          <Typography variant="body1" gutterBottom sx={{ mb: 2 }}>
            <strong>Event Timing </strong> : Live
          </Typography>
          <Typography variant="body1" gutterBottom sx={{ mb: 2 }}>
            <strong>About the Events</strong> : Subscribe for future live events
          </Typography>
          <Divider component="li" sx={{ mt: 3, mb: 6,listStyle:'none' }} />
          <Grid container spacing={2}>
            {liveStreamingUrlData?.map((data) => (
              <Grid xs={4} sx={{ textAlign: "center" }}>
                <Box sx={{ border: "6px solid #e4e4e4", m: 2 }}>
                  <a href={data?.url}>
                    <img src={data?.image} />
                  </a>
                </Box>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ mt: 2, fontWeight: 600 }}
                >
                  {data?.name}
                </Typography>
                <Typography
                  variant="body1"
                  gutterBottom
                  sx={{ textAlign: "center" }}
                >
                  {data?.timing === "Live" ? "" : data?.timing}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default Livestreaming;
